import { css } from "@emotion/react";
import { useTranslation } from "react-i18next";
import { getResourceI18nNamespace } from "src/system/getResourceI18nNamespace.ts";
import { Flex } from "src/components/Flex.tsx";
import { ButtonV2 } from "src/components/ButtonV2/ButtonV2.tsx";
import React from "react";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";

export const ResourceNotFound = ({
  resource,
  onReset,
}: {
  resource: string;
  onReset?: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <div css={container}>
      <h1 css={title}>404!</h1>
      <div>
        {t(`oneNotFound`, "Record is not found", {
          ns: getResourceI18nNamespace(resource),
        })}
      </div>
      <Flex
        flexShrink={0}
        style={{
          marginTop: "10px",
          minHeight: "0px",
        }}
      >
        <ButtonV2
          onClick={onReset}
          size={"sm"}
          variant={"filled"}
          startAdornment={<i className={"icon-15-update"} />}
        >
          {t("actions.reload", {
            ns: TranslationNamespaceEnum.Common,
          })}
        </ButtonV2>
      </Flex>
    </div>
  );
};

const container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: center;
`;

const title = css`
  margin-bottom: 0;
  margin-top: 0;
`;
